import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import React, { FC, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { InputContainer } from "modus/components/form/input-container/InputContainer";
import {ResourceAuthorizer} from "../../authorizer/components/Authorizer";

export interface NoAuthFormProps {
  deployedUrl?: string;
  deploymentId: string;
  deploymentStatus?: string;
  serviceId: string;
  onAddPath: (path: string, method: string) => void;
}

const allowedMethods = [
  { key: "GET", value: "GET" },
  { key: "POST", value: "POST" },
  { key: "PUT", value: "PUT" },
  { key: "PATCH", value: "PATCH" },
  { key: "DELETE", value: "DELETE" },
];

const NoAuthForm: FC<NoAuthFormProps> = ({
  deployedUrl,
  deploymentStatus,
  serviceId,
  onAddPath,
}) => {
  const [path, setPath] = useState<string>("");
  const [formMethod, setFormMethod] = useState<string>("");
  const [inputKey, setInputKey] = useState(0);

  const handleAddPath = () => {
    onAddPath(path, formMethod);
    setPath("");
    setFormMethod("");
    setInputKey((k) => k + 1);
  };

  const intl = useIntl();
  const isAddDisabled =
    deploymentStatus === "DEPLOYING" ||
    deploymentStatus === "DEPLOY_INITIATED" ||
    !path ||
    !formMethod;

  return (
    <>
      <span className="noauthheader">
        <FormattedMessage defaultMessage="Add API resources here that may need to bypass authentication, subscription validation, and gateway checks." />
      </span>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          marginTop: "16px",
          marginBottom: "16px",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ display: "inline-flex" }}>
          <TextField
            id="filled-basic"
            value={
              deployedUrl?.split("api")[0] +
              "..." +
              deployedUrl?.substring(deployedUrl?.length - 8)
            }
            variant="filled"
            disabled
            style={{
              height: "50px",
              marginTop: "2px",
              width: "450px",
            }}
          />
          <InputContainer
            key={inputKey}
            name="noAuthPath"
            data-testid="noauth-path"
            placeholder={intl.formatMessage({
              defaultMessage: "Add Resource",
            })}
            validate={{
              required: false,
            }}
            style={{
              height: "53px",
            }}
            onChange={(event) => {
              const val = event.target.value;
              setPath(val.startsWith("/") ? val : `/${val}`);
            }}
          />
        </Box>

        <Box style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <FormControl variant="outlined" style={{ minWidth: "120px" }}>
            <InputLabel id="noauth-methods-label">Method</InputLabel>
            <Select
              labelId="noauth-methods-label"
              id="noauth-methods"
              value={formMethod}
              label="Method"
              IconComponent={ExpandMoreIcon}
              displayEmpty
              style={{
                height: "56px",
              }}
              onChange={(event) => setFormMethod(event.target.value as string)}
            >
              {allowedMethods.map((method) => (
                <MenuItem key={method.key} value={method.value}>
                  {method.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddPath}
              style={{
                textTransform: "none",
                borderRadius: "4px",
                padding: "8px 24px",
                height: "56px",
                backgroundColor: (!isAddDisabled && path && formMethod) ? "#0063a3" : "#00000042",
              }}
              disabled={isAddDisabled}
            >
              <FormattedMessage defaultMessage="Add Path" />
            </Button>
          </ResourceAuthorizer>
        </Box>
      </Box>
    </>
  );
};
export default NoAuthForm;
